/*
 * 1DS JSLL SKU, 3.2.18
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
import { notImplementedWarn } from "./Utils";
var VortexEvents = /** @class */ (function () {
    function VortexEvents() {
    }
    VortexEvents.prototype.sendError = function (errorInfo, displayedToUser) {
        // NO OP
        notImplementedWarn("sendError");
    };
    VortexEvents.prototype.sendApiComplete = function (eventData) {
        // NO OP
        notImplementedWarn("sendApiComplete");
    };
    VortexEvents.prototype.sendJsllEvent = function (eventData) {
        // NO OP
        notImplementedWarn("sendJsllEvent");
    };
    VortexEvents.prototype.SendOrScheduleEvent = function (eventData, isCritical) {
        // NO OP
        notImplementedWarn("SendOrScheduleEvent");
    };
    VortexEvents.prototype.overrideQueueBehavior = function (options) {
        // NO OP
        notImplementedWarn("overrideQueueBehavior");
    };
    VortexEvents.prototype.drainQueuedEvents = function () {
        // NO OP
        notImplementedWarn("drainQueuedEvents");
    };
    VortexEvents.prototype.batchEventsByNumber = function (num) {
        // NO OP
        notImplementedWarn("batchEventsByNumber");
    };
    VortexEvents.prototype.batchQueuedEvents = function () {
        // NO OP
        notImplementedWarn("batchQueuedEvents");
    };
    VortexEvents.prototype.addEventToQueue = function (event) {
        // NO OP
        notImplementedWarn("addEventToQueue");
    };
    return VortexEvents;
}());
export { VortexEvents };
//# sourceMappingURL=VortexEvents.js.map